import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { first, map, switchMap, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { GenesysCloudConfigService } from 'common/genesys-cloud-config';

@Injectable({
  providedIn: 'root'
})
export class GenesysCloudPlatformApiService {
  protected apiHost: string;

  protected commonHeaders$;

  constructor(
    protected readonly httpClient: HttpClient,
    protected readonly configService: GenesysCloudConfigService) {

    this.commonHeaders$ = this.configService.apiConfig$.pipe(
      tap(apiConfig => this.apiHost = apiConfig.apiEndpoints.apiUri),
      map(apiConfig => ({ Authorization: `Bearer ${apiConfig.accessToken}`}))
    );
  }

  get$<T>(path: string, options?: {
    params?: HttpParams | {
      [param: string]: string | number | boolean | readonly (string | number | boolean)[];
    }
  }): Observable<T> {
    return this.getFirstCommonHeaders$().pipe(
      switchMap(commonHeaders => this.httpClient.get<T>(this.createUrl(path), {
        ...options,
        headers: commonHeaders
      }))
    );
  }

  post$<T>(path: string, body: any): Observable<T> {
    return this.getFirstCommonHeaders$().pipe(
      switchMap(commonHeaders => this.httpClient.post<T>(this.createUrl(path), body, {
        headers: commonHeaders
      }))
    );
  }

  patch$<T>(path: string, body: any): Observable<T> {
    return this.getFirstCommonHeaders$().pipe(
      switchMap(commonHeaders => this.httpClient.patch<T>(this.createUrl(path), body, {
        headers: commonHeaders
      }))
    );
  }

  delete$<T>(path: string,  options?: {
    params?: HttpParams | {
      [param: string]: string | number | boolean | readonly (string | number | boolean)[];
    }
  }): Observable<T> {
    return this.getFirstCommonHeaders$().pipe(
      switchMap(commonHeaders => this.httpClient.delete<T>(this.createUrl(path), {
        ...options,
        headers: commonHeaders
      }))
    );
  }

  put$<T>(path: string, body: any): Observable<T> {
    return this.getFirstCommonHeaders$().pipe(
      switchMap(commonHeaders => this.httpClient.put<T>(this.createUrl(path), body, {
        headers: commonHeaders
      }))
    );
  }

  protected createUrl(path: string): string {
    return `${this.apiHost}/${path}`;
  }

  private getFirstCommonHeaders$(): Observable<{ Authorization: string }> {
    return this.commonHeaders$.pipe(
      first()
    );
  }
}
